import { DeepPartial } from "./deepPartial";

export class Employee {
    employeeId: string = '';
    surname?: string = '';
    name?: string = '';
    type?: string = '';
    mail?: string = '';
    telephone?: string = '';
    writePermissions?: string[] = [];
    readPermissions?: string[] = [];
    chainAcounts?: ChainAccount[] = [];
}

export class ChainAccount {
    order: number = 0;
    employeeId: string = '';
    restaurantId: string = '';
    restaurantTitle?: string = '';
}


export class EmployeeUser {
    id: string = "";
    name: string = "";
    surname: string = "";
    restaurantId: string = "";
    username: string = "";
    password: string = "";
    mail: string = "";
    phone: string = "";
    type: EmployeeUserType = "Hostess_A";

    constructor(input?: DeepPartial<EmployeeUser>) {
        if (input) {
            for (const [key, value] of Object.entries(input)) {
                (this as any)[key] = value;
            }
        }
    }
}

export type EmployeeUserType =
    'Captain' |
    'Director' |
    'Manager' |
    'Hostess_A' |
    'Hostess_B' |
    'Chef' |
    'Parker' |
    'Server' |
    'Admin' |
    'Waiter' |
    'Hostess' |
    'FrontDesk' |
    'Viewer' |
    'PR';